import { useIntl } from 'react-intl'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'

import {
  IconWrapper,
  IconsGrid,
  BenefitCard,
  BenefitText,
} from './style'
import useWhyWorkForUsItems from './whyWorkForUsItems'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const IconPane = styled(Pane)`
  ${mediaQueryUp.tablet} {
    height: 100%;
  }
`

function WhyWorkForUs() {
  const intl = useIntl()
  const whyWorkForUsItems = useWhyWorkForUsItems()

  return <Pane background="neutral-six">
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Heading
          variant="heading3"
          align="center"
          as="h2"
        >
          {intl.formatMessage({
            id: 'mHOY_YejLpYUGrTpNFX7',
            defaultMessage: 'Why work for us?',
            description: 'Section heading for employee benefits on the careers page',
          })}
        </Heading>
        <BodyText as="p" variant="large" align="center">
          {intl.formatMessage({
            id: 'EiGdhj-aPFNC1LqC2_5p',
            defaultMessage: 'We consider our people one of our most important assets – and we want our team to love their working lives! When you work for Luxury Escapes, you can look forward to:',
            description: 'Introduction text for employee benefits section on the careers page',
          })}
        </BodyText>
        <IconsGrid>
          {whyWorkForUsItems.map((item) =>
            <IconWrapper key={item.title}>
              <IconPane border="neutral-five" borderRadius="S">
                <PaneBody size="md lg-y">
                  <BenefitCard>
                    <div>{item.icon}</div>
                    <BenefitText>
                      <BodyText variant="large" weight="bold">{item.title}</BodyText>
                      <BodyText variant="small">{item.text}</BodyText>
                    </BenefitText>
                  </BenefitCard>
                </PaneBody>
              </IconPane>
            </IconWrapper>,
          )}
        </IconsGrid>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default WhyWorkForUs
